// @ts-nocheck
import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
} from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../../../styles/ButtonTextStyle';
import React, { useContext } from 'react';
import LocalizationContext from '../../../../shared/contexts/LocalizationContext';
import LocalizationHelper from '../../../../helpers/TranslationHelper';
import { Localization, LocalizationEntity } from '../../../../shared/models/localization';

interface AlertDialogProps {
  message: string;
  isOpen: boolean;
  onClose: () => void;
  action: () => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({ message, isOpen, onClose, action }) => {
  const handleContinue = () => {
    action();
    onClose();
  };

  const localization = useContext<Array<LocalizationEntity>>(LocalizationContext);

  const archiveText: string = LocalizationHelper.getLocaleEntityValue(
    localization,
    'ZSite.Frontend.Move',
    'Archive'
  );

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: 'auto',
          },
        },
      }}
    >
      <DialogContent sx={{ fontSize: '18px', fontWeight: '500' }}>
        <div className="dialog-header-container">
          <DialogTitle>{message}</DialogTitle>

          <a onClick={onClose} className="cross-button">
            <span className="material-symbols-outlined">close</span>
          </a>
        </div>

        <ThemeProvider theme={theme}>
          <DialogActions sx={{ padding: 0 }}>
            <Button onClick={handleContinue} color="info" variant="contained">
              {archiveText}
            </Button>
          </DialogActions>
        </ThemeProvider>
      </DialogContent>
    </Dialog>
  );
};
